import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  KitchenBoardDto,
  BumpOrderResponse,
  KitchenDisplayServiceInterface,
} from "../types/kitchen.types";

export class KitchenDisplayService
  extends BaseService
  implements KitchenDisplayServiceInterface
{
  async getKitchenBoard(): Promise<ApiResult<KitchenBoardDto>> {
    return this.handleRequest<KitchenBoardDto>(
      this.client.get("/api/admin/food-orders/kitchen"),
    );
  }

  async bumpOrder(orderId: string): Promise<ApiResult<BumpOrderResponse>> {
    return this.handleRequest<BumpOrderResponse>(
      this.client.put(`/api/admin/food-orders/kitchen/${orderId}/bump`),
    );
  }
}
